<div class="wrap">
  <fa-icon [icon]="getFaIcon('faTimes')" class="close" (click)="closePopup()"></fa-icon>
  <fa-icon [icon]="getFaIcon('faUndoAlt')" class="reset" (click)="resetSearch()"></fa-icon>
  <div class="checkbox">
    <mat-checkbox [color]="color" *ngFor="let c of valueFilterChoice" [checked]="c.isCheck" (click)="addOrDeleteFilter(c.value); $event.stopPropagation()">{{c.value}}</mat-checkbox>
  </div>
</div>
